import React from "react";
import { IonContent } from "@ionic/react";
import SitePhotos from "./SitePhotos";
import { SitePhoto } from "../models/SitePhoto";
import { User } from "../models/User";
import { PermitAffectedService } from "../models/PermitAffectedService";
import { SitePhotoType } from "../models/SitePhotoType";

interface Props {
    permitId: string;
    sitePhotos?: SitePhoto[];
    onSitePhotoCaptured: (dataUrl: string) => void;
    onSitePhotoDeleted: (sitePhotoId: string) => void;
    isReadOnly: boolean;
    ableToAddPhotos: boolean;
    editablePhotoTypes: SitePhotoType[];
    permitRegisterUsers: User[];
    affectedServices: PermitAffectedService[];
    onAffectedServicePhotoCaptured: (dataUrl: string, affectedService: PermitAffectedService, comments: string) => void;
    onAffectedServiceNoPhotoReason: (affectedService: PermitAffectedService, reason: string) => void;
}

const PermitSitePhotosTab: React.FC<Props> = ({
    permitId,
    sitePhotos,
    onSitePhotoCaptured,
    onSitePhotoDeleted,
    isReadOnly,
    ableToAddPhotos,
    editablePhotoTypes,
    permitRegisterUsers,
    affectedServices,
    onAffectedServicePhotoCaptured,
    onAffectedServiceNoPhotoReason,
}) => {
    return (
        <IonContent>
            <SitePhotos
                permitId={permitId}
                isReadOnly={isReadOnly}
                sitePhotos={sitePhotos}
                onSitePhotoCaptured={onSitePhotoCaptured}
                onSitePhotoDeleted={onSitePhotoDeleted}
                ableToAddPhotos={ableToAddPhotos}
                editablePhotoTypes={editablePhotoTypes}
                permitRegisterUsers={permitRegisterUsers}
                affectedServices={affectedServices}
                onAffectedServicePhotoCaptured={onAffectedServicePhotoCaptured}
                onAffectedServiceNoPhotoReason={onAffectedServiceNoPhotoReason}
            />
        </IonContent>
    );
};

export default PermitSitePhotosTab;
